module.exports = __webpack_public_path__ + "img/1574317353(1).1b4f2252.png";